<!-- Header (Logo bar) -->
<div id="headerBar">
  <div id="headerBarCapWidth">
    <!-- @if (smallScreen) {
      <span class="flex">
        <button mat-button (click)="navMenu.toggle()">
          <mat-icon [svgIcon]="'feather:menu'"></mat-icon>
        </button>
      </span>
    } -->
    <span class="flex">
      <a [routerLink]="''">
        <img id="headerLogo" src="assets/images/logo/wa_logo_white_yellow.svg" />
      </a>
    </span>
    @if (!smallScreen) {
      <span class="flex">
        <button mat-button class="headerBarItem" (click)="logout()">
          <mat-icon [svgIcon]="'feather:log-out'"></mat-icon>
          Logout
        </button>
      </span>
    }
    @if (smallScreen) {
      <span class="flex flex-end">
        <button mat-icon-button class="headerBarItem" [matMenuTriggerFor]="accountMenu">
          <mat-icon [svgIcon]="'feather:more-horizontal'"></mat-icon>
        </button>
      </span>
    }
  </div>
</div>
<div class="content-container">
  <div class="locked-account-content mat-typography">
    <div>
      <img src="assets/icons/lock.svg" />
      <div class="pageHeading">Account locked</div>
      <div>
        @if (lockReason == 'other') {
          <p>Your account has been locked.</p>
        }
        @if (lockReason != 'other') {
          <p>Your account has been locked due to {{ lockReason }}.</p>
        }
        @if (lockReason == 'outstanding invoices') {
          <div>
            <button class="call-to-action-button" mat-flat-button
              (click)="viewInvoicesClicked()"><strong>View invoices</strong></button>
            </div>
          }
          <p>Please contact our friendly team of wine cellarage experts for further information.</p>
        </div>
        <button class="call-to-action-button" mat-flat-button (click)="contactUsClicked()"><strong>Contact us</strong></button>
      </div>
    </div>
  </div>
  <footer id="footer">
    <div id="siteMap">
      <div id="siteMapCapWidth" [ngClass]="{'footerSmallScreen': smallScreen}">
        <div class="footerSiteMapColumn">
          <label class="footerHeader">Shop</label>
          <a href="/category/listings">Wines</a>
          <a href="/accessories">Accessories</a>
        </div>
        <div class="footerSiteMapColumn">
          <label class="footerHeader">About</label>
          <a href="/about">About us</a>
          <a href="/about/why-wine-ark">Why join?</a>
        </div>
        <div class="footerSiteMapColumn">
          <label class="footerHeader">Help</label>
          <a href="/resources/faq">FAQ</a>
          <a [href]="getTermsAndConditionsUrl()">Terms and conditions</a>
        </div>
        <div class="footerSiteMapColumn">
          <label class="footerHeader">Contact</label>
          <span class="content-center flex footerIcon"><mat-icon [svgIcon]="'feather:phone'"></mat-icon><a href="tel:1300 946 327">1300 946 327</a></span>
          <span class="content-center flex footerIcon"><mat-icon [svgIcon]="'feather:mail'"></mat-icon><a href="contact">Email us</a></span>
          <label class="footerHeader">Follow us</label>
          <span>
            <a href="https://twitter.com/wineark"><mat-icon [svgIcon]="'feather:twitter'"></mat-icon></a>
            <a href="https://www.facebook.com/wineark"><mat-icon [svgIcon]="'feather:facebook'"></mat-icon></a>
            <a href="https://www.instagram.com/wine_ark"><mat-icon [svgIcon]="'feather:instagram'"></mat-icon></a>
          </span>
        </div>
        <div class="footerSiteMapColumn">
          <a href="https://www.wineark.com.au">
            <img src="assets/images/logo/ns_wa_logo_white_yellow.svg">
          </a>
        </div>
      </div>
    </div>
    <div id="copyright">
      <p>© Wine Ark. All rights reserved.</p>
    </div>
  </footer>
  <mat-menu #accountMenu="matMenu">
    <button class="headerBarItem" mat-menu-item (click)="logout()">
      <mat-icon [svgIcon]="'feather:log-out'"></mat-icon>
      Logout
    </button>
  </mat-menu>
